import { Box, TextField, Typography, useTheme } from "@mui/material";
import EditIconfrom from "../../../../media/images/icons/edit-icon";
import React from "react";

export default function OtpInput() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography
        sx={{
          color: "primary.light",
          fontWeight: "600",
          fontSize: "13px",
        }}
      >
        کد اعتبارسنجی به شماره تلفن همراه شما ارسال شد.
      </Typography>
      <Box
        sx={{
          display: "flex",
          paddingX: "8px",
          paddingY: "4px",
          mt: 2,
          justifyContent: "space-between",
          alignItems: "center",
          borderWidth: "2px",
          borderColor: "textColor.light",
          borderRadius: "12px",
          borderStyle: "solid",
        }}
      >
        <TextField
          placeholder="----"
          style={{
            textAlign: "center",
          }}
          sx={{
            "& fieldset": { border: "none" },
          }}
          InputProps={{
            disableUnderline: true,
            dir: "ltr",
          }}
          inputProps={{
            style: {
              textAlign: "center",
              height: "15px",
              fontSize: 18,
            },
          }}
        />
        <Box
          sx={{
            padding: "8px",
            borderRadius: "8px",
            bgcolor: "textColor.light",
          }}
        >
          <Typography
            sx={{
              color: "background.default",
            }}
          >
            03:00
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            color: "primary.main",
          }}
        >
          تغییر شماره
        </Typography>
        <EditIconfrom color={theme.palette.primary.main} />
      </Box>
    </Box>
  );
}
